import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import type { RolFirma } from '@condo/contracts';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface ActaFirmarDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  rol: RolFirma;
  isPending: boolean;
  onConfirm: () => void;
}

const ROL_LABELS: Record<RolFirma, string> = {
  administrador: 'administrador',
  presidente: 'presidente de mesa',
};

export function ActaFirmarDialog({
  open,
  onOpenChange,
  rol,
  isPending,
  onConfirm,
}: ActaFirmarDialogProps) {
  const [entendido, setEntendido] = useState(false);

  function handleOpenChange(v: boolean) {
    if (!v) setEntendido(false);
    onOpenChange(v);
  }

  function handleConfirm() {
    if (!entendido) return;
    onConfirm();
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Firmar acta como {ROL_LABELS[rol]}</DialogTitle>
          <DialogDescription>
            Vas a firmar el acta como <strong>{ROL_LABELS[rol]}</strong>. Esta accion usa FEA
            mock (pendiente de integracion FEA real con proveedor certificado).
          </DialogDescription>
        </DialogHeader>

        <label className="flex cursor-pointer items-start gap-3 rounded-md border border-[var(--color-hairline)] bg-[var(--color-paper-dim)] p-4 text-sm">
          <input
            type="checkbox"
            className="mt-0.5 h-4 w-4 shrink-0 accent-[var(--color-primary)]"
            checked={entendido}
            onChange={(e) => setEntendido(e.target.checked)}
          />
          <span className="text-[var(--color-ink-soft)]">
            Entiendo que es firma mock y que la integracion FEA real esta pendiente.
          </span>
        </label>

        <DialogFooter>
          <Button
            variant="ghost"
            onClick={() => handleOpenChange(false)}
            disabled={isPending}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={!entendido || isPending}
          >
            {isPending ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Firmando…
              </>
            ) : (
              'Firmar acta'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
